import React from "react";

const PIPELINE_STEPS = [
  { title: "Showcase", sub: "Foundation" },
  { title: "Promotion", sub: "Active Push" },
  { title: "Discovery", sub: "Market Reach" },
  { title: "Connection", sub: "Relevant Node" },
  { title: "Opportunity", sub: "Commercial Flow", highlight: true },
];

export default function TransformativeValue() {
  return (
    <section className="section-py">
      <div className="container-selectezi">
        <div className="section-head-m">
          <span className="eyebrow-label">Transformative Value</span>
          <h2 className="section-title m-auto text-center">
            From Passive Showcase to Active Promotion
          </h2>
          <p className="section-subtitle mx-auto">
            Traditional platforms let profiles sit dormant. A SELECTEZI
            Marketing Agent transforms static cataloging into progressive,
            synchronized promotional traction.
          </p>
        </div>

        <div className="row g-4">
          <div className="col-lg-4">
            <div className="compare-panel is-static">
              <span className="pill-tag muted">
                <i className="bi bi-circle-fill" style={{ fontSize: 6 }} />
                Static Directory Model
              </span>
              <h3 className="feature-title" style={{ fontSize: 22 }}>
                Normal Showcase
              </h3>
              <p className="feature-text">
                Business creates a presence and waits to be discovered
              </p>

              <div className="mini-stat-card">
                <i className="bi bi-record-circle" style={{ fontSize: 18 }} />
                <div>
                  <div className="feature-title" style={{ fontSize: 15, marginBottom: 2 }}>
                    Passive Status
                  </div>
                  <p className="feature-text" style={{ fontSize: 13.5 }}>
                    Zero routing activity, dormant search index
                  </p>
                </div>
              </div>

              <p
                className="feature-text mt-5 mb-0"
                style={{ fontSize: 12, fontWeight: 700, letterSpacing: "0.05em", textTransform: "uppercase" }}
              >
                Traditional Online Directory
              </p>
            </div>
          </div>

          <div className="col-lg-8">
            <div className="compare-panel is-active">
              <span className="pill-tag solid">
                <i className="bi bi-circle-fill" style={{ fontSize: 6 }} />
                Active Agent Pipeline
              </span>
              <h3 className="feature-title" style={{ fontSize: 22 }}>
                SELECTEZI Marketing Agent
              </h3>
              <p className="feature-text">
                An active operational agent continuously champions your
                products, services, and commercial value across targeted
                networks
              </p>

              <div className="pipeline-strip">
                {PIPELINE_STEPS.map((step) => (
                  <div
                    key={step.title}
                    className={`pipeline-chip${step.highlight ? " is-highlight" : ""}`}
                  >
                    <i
                      className={`bi ${
                        step.highlight ? "bi-rocket-takeoff" : "bi-check2-circle"
                      }`}
                      style={{ fontSize: 20 }}
                    />
                    <span className="chip-label">{step.title}</span>
                    <span className="chip-sub">{step.sub}</span>
                  </div>
                ))}
              </div>

              <div className="quote-card">
                <span className="quote-mark">99</span>
                <div>
                  <p className="feature-title mb-1" style={{ fontSize: 16 }}>
                    &ldquo;Don&apos;t just create a Showcase. Put your
                    Showcase to work&rdquo;
                  </p>
                  <span style={{ color: "var(--c-primary)", fontWeight: 700, fontSize: 13.5 }}>
                    The SELECTEZI Marketing Paradigm
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
